// 261010 UI-icons — nút phụ dạng biểu tượng: Tooltip mang nhãn tiếng Việt, aria-label = nhãn. Nút tắt vẫn có Tooltip (bọc span để chuột vào được). Không có handler riêng — chỉ vẽ.
import React from 'react';
import { Tooltip } from 'antd';
import WfIcon from './WfIcon';
import type { IconName } from './workflowStatusIcons';

interface Props {
  icon: IconName;
  label: string;
  /** Lý do khi tắt (nối vào Tooltip). */
  why?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  testId?: string;
  className?: string;
  /** Chữ hiện cạnh biểu tượng (nút nổi bật / số đếm). */
  children?: React.ReactNode;
  expanded?: boolean;
  pressed?: boolean;
  /** Đang chạy: biểu tượng xoay + khoá nút (nhãn Tooltip giữ nguyên). */
  loading?: boolean;
}

const WfIconButton: React.FC<Props> = ({ icon, label, why, onClick, disabled, testId, className, children, expanded, pressed, loading }) => (
  <Tooltip title={disabled && why ? `${label} — ${why}` : label}>
    <span className="wf-ib-w">
      <button type="button" className={`wf-btn wf-ib${children ? ' txt' : ''}${className ? ` ${className}` : ''}`} aria-label={label} disabled={disabled || loading} onClick={onClick}
        data-testid={testId} aria-expanded={expanded} aria-pressed={pressed}>
        <WfIcon name={loading ? 'loading' : icon} />{children}
      </button>
    </span>
  </Tooltip>
);

export default WfIconButton;
